module.exports = __webpack_public_path__ + "img/icon-phone.e1d778ec.svg";